"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var LanguageJapaneseOutline = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_LanguageJapaneseOutline_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m6.929 4.536 1.04.032c-.038.119-.066.233-.091.339l-.021.085c-.028.133-.054.279-.08.435.975-.039 1.84-.136 2.712-.347l.007.92c-.777.142-1.847.243-2.835.29-.025.236-.047.479-.063.722a5.459 5.459 0 0 1 1.341-.137c.036-.168.064-.37.07-.491l.984.24a5.96 5.96 0 0 0-.15.407c.935.304 1.55 1.022 1.55 1.953 0 1.136-.673 2.232-2.632 2.536l-.536-.848c1.544-.168 2.175-.944 2.175-1.736 0-.477-.287-.904-.833-1.115C9.134 8.902 8.5 9.74 7.884 10.25c.056.207.117.405.18.598l-.92.272c-.033-.1-.066-.21-.099-.326-.387.192-.816.326-1.244.326-.584 0-1.072-.352-1.072-1.168 0-1.033.844-2.106 1.963-2.636.017-.336.044-.674.074-.998l-.253.002c-.307 0-.72-.021-1.066-.039l-.358-.017-.024-.92a13.319 13.319 0 0 0 1.792.103 217.295 217.295 0 0 1 .048-.423c.016-.16.032-.344.024-.488Zm-.254 3.736c-.602.408-1.002 1.022-1.002 1.472 0 .264.104.4.368.4.224 0 .505-.094.8-.267a10.914 10.914 0 0 1-.166-1.605Zm.988.937A4.803 4.803 0 0 0 8.675 7.68a3.893 3.893 0 0 0-1.106.18v.019c0 .493.035.93.094 1.329Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0Zm-1 0A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_LanguageJapaneseOutline_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = LanguageJapaneseOutline;
exports["default"] = _default;